module.exports = __webpack_public_path__ + "static/img/group.8f037d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group.png
// module id = wiDa
// module chunks = 1